import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1a3013f2")

_pushScopeId("data-v-1a3013f2")
const _hoisted_1 = { class: "call-panel" }
const _hoisted_2 = {
  key: 0,
  class: "panel-mobile"
}
const _hoisted_3 = {
  key: 1,
  class: "panel"
}
const _hoisted_4 = { class: "setting-wrap" }
const _hoisted_5 = { class: "video-settings" }
const _hoisted_6 = { class: "user-settings" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SharingButton = _resolveComponent("SharingButton")
  const _component_Button = _resolveComponent("Button")
  const _component_MeetingInfoWithPopup = _resolveComponent("MeetingInfoWithPopup")
  const _component_Tooltip = _resolveComponent("Tooltip")
  const _component_AudioButton = _resolveComponent("AudioButton")
  const _component_VideoButton = _resolveComponent("VideoButton")
  const _component_MenuButton = _resolveComponent("MenuButton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isMobileScreen)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          (_ctx.canScreen())
            ? (_openBlock(), _createBlock(_component_SharingButton, {
                key: 0,
                class: "icon"
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_Button, {
            class: "icon",
            size: "l",
            mode: "outlined",
            icon: { spriteUrl: "/image/videoconf-icons.svg", name: _ctx.iconMicName, color: "--sui-gray-700" },
            disabled: false,
            iconOnly: "",
            onClick: _ctx.toggleAudio
          }, null, 8, ["icon", "onClick"]),
          _createVNode(_component_Button, {
            class: "icon",
            size: "l",
            mode: "outlined",
            icon: { spriteUrl: "/image/videoconf-icons.svg", name: _ctx.iconCamName, color: "--sui-gray-700" },
            disabled: false,
            iconOnly: "",
            onClick: _ctx.toggleVideo
          }, null, 8, ["icon", "onClick"]),
          _createVNode(_component_Button, {
            class: "icon",
            mode: "alert",
            size: "l",
            icon: { spriteUrl: '/image/videoconf-icons.svg', name: 'ic25-leave-call-white'},
            onClick: _ctx.leaveConference
          }, null, 8, ["icon", "onClick"]),
          _createVNode(_component_Button, {
            class: "icon",
            size: "l",
            mode: "flat",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleOpenDrawer('settings'))),
            icon: { spriteUrl: '/image/videoconf-icons.svg', name: 'ic25-more', color: '--sui-gray-700' },
            disabled: false,
            iconOnly: ""
          }, null, 8, ["icon"])
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_Tooltip, {
              class: "button",
              text: _ctx.t('buttons.info')
            }, {
              button: _withId(() => [
                _createVNode(_component_MeetingInfoWithPopup, {
                  link: 'videoconf.voximplant.com' + _ctx.path,
                  name: _ctx.params.conference
                }, null, 8, ["link", "name"])
              ]),
              _: 1
            }, 8, ["text"])
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_Tooltip, {
              class: "button",
              text: _ctx.sharingTooltip
            }, {
              button: _withId(() => [
                (_ctx.canScreen())
                  ? (_openBlock(), _createBlock(_component_SharingButton, { key: 0 }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["text"]),
            _createVNode(_component_AudioButton, { class: "btn-icon-chevron" }),
            _createVNode(_component_VideoButton, { class: "btn-icon-chevron" }),
            _createVNode(_component_Tooltip, {
              class: "button",
              text: _ctx.t('buttons.leave')
            }, {
              button: _withId(() => [
                _createVNode(_component_Button, {
                  mode: "alert",
                  size: "l",
                  icon: { spriteUrl: '/image/videoconf-icons.svg', name: 'ic25-leave-call-white'},
                  onClick: _ctx.leaveConference
                }, null, 8, ["icon", "onClick"])
              ]),
              _: 1
            }, 8, ["text"])
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_Tooltip, {
              text: _ctx.t('buttons.settings')
            }, {
              button: _withId(() => [
                _createVNode(_component_MenuButton, { class: "btn-icon-sq" })
              ]),
              _: 1
            }, 8, ["text"])
          ])
        ]))
  ]))
})